module.exports = __webpack_public_path__ + "img/c04_unittechtraderoutes_Normal_ua.bbeda50c.webp";